import PUApi from './_puApi';

class PUVendorPaymentAPI extends PUApi {
  constructor() {
    super();
  }
  controllerName = 'PUVendorPayments';
}

export default new PUVendorPaymentAPI();
